export default "__VITE_ASSET__DMRzbwTG__"